export { mapMedpraxSpecialtyToSpecialty } from './mapping';
export type { Specialty } from './schema';
export { SpecialtySchema } from './schema';
